webpackJsonp([1],{

/***/ "Fvg5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screen",attrs:{"id":"app"}},[_c('div',{staticClass:"screen-outer"},[_c('div',{staticClass:"screen-glare"}),_c('div',{staticClass:"screen-inner"},[(_vm.phase == 0)?_c('div',{staticClass:"start"},[_c('h1',{staticClass:"start-title"},[_vm._v("programming language test")]),(!_vm.loading)?_c('p',{staticClass:"start-notification"},[_vm._v("press enter to start test")]):_vm._e(),_c('span',{staticClass:"team"},[_vm._v("pxlhead tm")]),(_vm.loading)?_c('div',{staticClass:"loader"},[_c('span',{staticClass:"loader-title"},[_vm._v("Loading")]),_c('span',{staticClass:"loader-bar"},[_vm._v(_vm._s(_vm.loaderBar))])]):_vm._e()]):_vm._e(),(_vm.phase == 1)?_c('div',{staticClass:"test"},[_c('h3',{staticClass:"test-question"},[_vm._v(_vm._s(_vm.activeTest.question))]),_c('div',{staticClass:"test-answers"},_vm._l((_vm.activeTest.answers),function(answer,index){return _c('span',{staticClass:"answer",class:{ "answer--active": index == _vm.activeAnswer },on:{"click":function($event){_vm.activeAnswer = index}}},[_vm._v(_vm._s(answer))])}))]):_vm._e(),(_vm.phase == 2)?_c('div',{staticClass:"result"},[(_vm.loading)?_c('div',{staticClass:"loader"},[_c('span',{staticClass:"loader-title"},[_vm._v(_vm._s(_vm.loaderText))])]):_c('div',{staticClass:"result-message"},[_c('h3',{staticClass:"result-text"},[_vm._v("Try not. Do "+_vm._s(_vm.result)+" – or do not "+_vm._s(_vm.result)+". There is no try.")]),_c('span',{staticClass:"result-notification"},[_vm._v("Enter press to restart and be mindful.")])])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kbsk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  question: 'What is your purpose of studying?',
  answers: ['Web development', 'Software development', 'Mobile app development'],
  '0': {
    question: 'Do you like interacting with people?',
    answers: ['I\'m good with people', 'I hate them all'],
    '0': {
      question: 'Are you a creative person?',
      answers: ['I\'m a man of beauty', 'Functionality is more important for me'],
      '0': 'HTML + CSS',
      '1': 'JS'
    },
    '1': {
      question: 'Are you a workaholic?',
      answers: ['Personal life is more important for me', 'Work is my credo'],
      '0': {
        question: 'Are you conservative or liberal?',
        answers: ['I love sorting out retro things', 'I\'m futurist'],
        '0': 'PHP',
        '1': 'Node.js'
      },
      '1': {
        question: 'What kind kind of music do you prefer?',
        answers: ['Retrowave', 'Power metal', 'Alternative', 'Pop'],
        '0': 'C#',
        '1': 'Java',
        '2': 'Ruby',
        '3': 'Python'
      }
    }
  },
  '1': {
    question: 'How do you usually spend your free time?',
    answers: ['Gaming!', 'Reinstalling OS', 'Thinking of business ideas', 'Building my own C-3PO', 'Doing my homework'],
    '0': {
      question: 'Which type of game you play last time?',
      answers: ['Indie', 'AAA', 'Text', 'MMORPG'],
      '0': {
        question: 'Which styles of visual art do you prefer?',
        answers: ['Realism', 'Surrealism', 'Cubism', 'Post-modernism', 'Avant-garde', 'Primitivism'],
        '0': 'C++',
        '1': 'C#',
        '2': 'Java',
        '3': 'Python',
        '4': 'JS',
        '5': 'Delphi'
      },
      '1': {
        question: 'What is you favourite weapon in games?',
        answers: ['Bow to shot at someone\'s knee 🏹', 'Magic/Biotics/Psyonics', 'Knife (no matter what game it is)'],
        '0': 'C++',
        '1': 'C#',
        '2': 'Java'
      },
      '2': {
        question: 'Which type of literature whould you choose?',
        answers: ['Fantasy', 'Sci-fi', 'Manual/Docs/Guide', 'Documentary', 'Classic', 'Novel', 'Comics (OMG)'],
        '0': 'C++',
        '1': 'C#',
        '2': 'Java',
        '3': 'Python',
        '4': 'Delphi',
        '5': 'JS',
        '6': 'ActionScript'
      },
      '3': {
        question: 'Which fictional race would you like to be?',
        answers: ['Hafling', 'Dwarf', 'Klingon', 'Borg', 'Wookiee', 'Azari', 'Troll'],
        '0': 'C++',
        '1': 'C#',
        '2': 'Java',
        '3': 'Python',
        '4': 'Delphi',
        '5': 'JS',
        '6': 'ActionScript'
      }
    },
    '1': {
      question: 'Which OS do you reinstall?',
      answers: ['Windows 😩', 'Linux (reboot now)', 'MacOS'],
      '0': {
        question: 'Which character would you be in the world of LOTR?',
        answers: ['J. R. R. Tolkien', 'Sauron', 'Gandalf', 'What is LOTR?', 'Treebeard', 'Dumbledore'],
        '0': 'C',
        '1': 'C++',
        '2': 'Java',
        '3': 'Rust',
        '4': 'Delphi',
        '5': 'Visual Basic'
      },
      '1': {
        question: 'Which fiction film do you like?',
        answers: ['Star Trek (old)', 'Star Trek (new)', 'Star Wars', 'Men in black', 'Space Odyssey', 'Interstellar'],
        '0': 'C',
        '1': 'C++',
        '2': 'Java',
        '3': 'Python',
        '4': 'Delphi',
        '5': 'Go'
      },
      '2': {
        question: 'Where would you spend your holidays?',
        answers: ['Home', 'Parent\'s home', 'Friend\'s home', 'Silicon Valley', 'Holidays?'],
        '0': 'C',
        '1': 'C++',
        '2': 'Objective-C',
        '3': 'Swift',
        '4': 'Java'
      }
    },
    '2': {
      question: 'Which way would you choose to conquer the world?',
      answers: ['Political', 'Economical', 'Social', 'Military'],
      '0': 'C++',
      '1': 'Java',
      '2': 'Python',
      '3': 'Ada'
    },
    '3': {
      question: 'Which genre of fiction do you prefer?',
      answers: ['Steampunk', 'Sci-fi', 'Cyberpunk'],
      '0': 'Assembler',
      '1': 'C',
      '2': 'Go'
    },
    '4': {
      question: 'Which subject would be the first?',
      answers: ['Math', 'Economics', 'Statistics', 'Informatics', 'Physics'],
      '0': 'Matlab',
      '1': 'Java',
      '2': 'R',
      '3': 'Python',
      '4': 'C'
    }
  },
  '2': {
    question: 'CEO of which company would you like to be?',
    answers: ['Apple', 'Google', 'Windows'],
    '0': {
      question: 'Which coffee do you like?',
      answers: ['Latte', 'Сappuccino', 'Espresso'],
      '0': 'Swift',
      '1': 'Objective-C',
      '2': 'Java'
    },
    '1': {
      question: 'Which cuisine do you like?',
      answers: ['Chinese', 'European', 'Elvish', 'Mexican'],
      '0': 'Objective-C',
      '1': 'Java',
      '2': 'JS',
      '3': 'Python'
    },
    '2': {
      question: 'Which cuisine do you like?',
      answers: ['Chinese', 'European', 'Elvish', 'Mexican'],
      '0': 'Objective-C',
      '1': 'Java',
      '2': 'JS',
      '3': 'Python'
    }
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b81117ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Fvg5");
function injectStyle (ssrContext) {
  __webpack_require__("PQM+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b81117ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "PQM+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__testData__ = __webpack_require__("Kbsk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',

  data: function data() {
    return {
      phase: 0,
      loading: false,
      loaderBar: '',
      loaderPhrases: ['Collecting your answers...', 'Comparing answers with PL matrix...', 'Testing your patience...', 'Analizing...'],
      activePhrase: 0,
      activeAnswer: 0,
      answersStack: [],
      result: ''
    };
  },
  mounted: function mounted() {
    document.addEventListener('keydown', this.onKeydown);
  },


  computed: {
    activeTest: function activeTest() {
      var result = __WEBPACK_IMPORTED_MODULE_0__testData__["a" /* default */];
      this.answersStack.forEach(function (answer) {
        result = result[answer];
      });
      if (typeof result !== 'string') return result;
      this.showResult(result);
      return {};
    },
    loaderText: function loaderText() {
      if (this.activePhrase == -1) return;
      return this.loaderPhrases[this.activePhrase];
    }
  },

  methods: {
    showResult: function showResult(result) {
      var _this = this;

      this.phase = 2;
      this.loading = true;
      this.result = result;

      var timerId = setInterval(function () {
        return _this.activePhrase++;
      }, 1500);
      setTimeout(function () {
        clearInterval(timerId);
        _this.loading = false;
        _this.activePhrase = 0;
      }, this.loaderPhrases.length * 1500);
    },
    onKeydown: function onKeydown(e) {
      var _this2 = this;

      if (this.phase == 0 && e.keyCode == 13) {
        this.loading = true;
        var timerId = setInterval(function () {
          return _this2.loaderBar += '#';
        }, 500);
        setTimeout(function () {
          clearInterval(timerId);
          _this2.loading = false;
          _this2.phase = 1;
        }, 3000);
      } else if (this.phase == 1) {
        if (e.keyCode == 13) {
          this.answersStack.push(this.activeAnswer);
          this.activeAnswer = 0;
        } else if (e.keyCode == 38) {
          this.activeAnswer = this.activeAnswer > 0 ? this.activeAnswer - 1 : this.activeTest.answers.length - 1;
        } else if (e.keyCode == 40) {
          this.activeAnswer = this.activeAnswer < this.activeTest.answers.length - 1 ? this.activeAnswer + 1 : 0;
        }
      } else if (e.keyCode == 13) {
        this.phase = 0;
        this.answersStack = [];
        this.loaderBar = '';
      }
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.dd43cd118c49c6b81658.js